module.exports = __webpack_public_path__ + "static/media/app-bar-logo.68550dc2.svg";